// Common FIX tag names for readability
const FIX_TAG_NAMES = {
  8: "BeginString",
  9: "BodyLength",
  10: "CheckSum",
  11: "ClOrdID",
  14: "CumQty",
  15: "Currency",
  17: "ExecID",
  20: "ExecTransType",
  21: "HandlInst",
  22: "SecurityIDSource",
  35: "MsgType",
  37: "OrderID",
  38: "OrderQty",
  39: "OrdStatus",
  40: "OrdType",
  44: "Price",
  48: "SecurityID",
  49: "SenderCompID",
  50: "SenderSubID",
  52: "SendingTime",
  54: "Side",
  55: "Symbol",
  56: "TargetCompID",
  57: "TargetSubID",
  58: "Text",
  59: "TimeInForce",
  60: "TransactTime",
  75: "TradeDate",
  98: "EncryptMethod",
  100: "ExDestination",
  108: "HeartBtInt",
  109: "ClientID",
  110: "MinQty",
  111: "MaxFloor",
  112: "TestReqID",
  115: "OnBehalfOfCompID",
  116: "OnBehalfOfSubID",
  122: "OrigSendingTime",
  126: "ExpireTime",
  128: "DeliverToCompID",
  129: "DeliverToSubID",
  141: "ResetSeqNumFlag",
  150: "ExecType",
  151: "LeavesQty",
  167: "SecurityType",
  198: "SecondaryOrderID",
  200: "MaturityMonthYear",
  201: "PutOrCall",
  202: "StrikePrice",
  207: "SecurityExchange",
  223: "CouponRate",
  225: "IssueDate",
  226: "RepurchaseTerm",
  227: "RepurchaseRate",
  228: "Factor",
  231: "ContractMultiplier",
  262: "MDReqID",
  263: "SubscriptionRequestType",
  264: "MarketDepth",
  265: "MDUpdateType",
  267: "NoMDEntryTypes",
  268: "NoMDEntries",
  269: "MDEntryType",
  270: "MDEntryPx",
  271: "MDEntrySize",
  272: "MDEntryDate",
  273: "MDEntryTime",
  279: "MDUpdateAction",
  280: "MDEntryRefID",
  281: "MDReqRejReason",
  336: "TradingSessionID",
  340: "TradSesStatus",
  369: "LastMsgSeqNumProcessed",
  371: "RefTagID",
  372: "RefMsgType",
  373: "SessionRejectReason",
  380: "BusinessRejectReason",
  383: "MaxMessageSize",
  384: "NoMsgTypes",
  385: "MsgDirection",
  423: "PriceType",
  432: "ExpireDate",
  434: "CxlRejResponseTo",
  439: "ClearingFirm",
  440: "ClearingAccount",
  442: "MultiLegReportingType",
  448: "PartyID",
  447: "PartyIDSource",
  452: "PartyRole",
  453: "NoPartyIDs",
  454: "NoSecurityAltID",
  455: "SecurityAltID",
  456: "SecurityAltIDSource",
  526: "SecondaryClOrdID",
  527: "SecondaryExecID",
  528: "OrderCapacity",
  529: "OrderRestrictions",
  530: "MassCancelRequestType",
  531: "MassCancelResponse",
  532: "MassCancelRejectReason",
  548: "CrossID",
  549: "CrossType",
  550: "CrossPrioritization",
  552: "NoSides",
  553: "Username",
  554: "Password",
  555: "NoLegs",
  600: "LegSymbol",
  602: "LegSecurityID",
  603: "LegSecurityIDSource",
  604: "NoLegSecurityAltID",
  605: "LegSecurityAltID",
  606: "LegSecurityAltIDSource",
  607: "LegProduct",
  608: "LegCFICode",
  609: "LegSecurityType",
  610: "LegMaturityMonthYear",
  611: "LegMaturityDate",
  612: "LegStrikePrice",
  613: "LegOptAttribute",
  614: "LegContractMultiplier",
  615: "LegCouponRate",
  616: "LegSecurityExchange",
  617: "LegIssuer",
  618: "EncodedLegIssuerLen",
  619: "EncodedLegIssuer",
  620: "LegSecurityDesc",
  621: "EncodedLegSecurityDescLen",
  622: "EncodedLegSecurityDesc",
  623: "LegRatioQty",
  624: "LegSide",
  625: "TradingSessionSubID",
  654: "LegRefID",
  658: "QuoteRequestRejectReason",
  660: "AcctIDSource",
  668: "DeliveryForm",
  715: "ClearingBusinessDate",
  779: "LastUpdateTime",
  828: "TrdType",
  829: "TrdSubType",
  830: "TransferReason",
  853: "ShortSaleReason",
  856: "TradeReportType",
  880: "TrdMatchID",
  881: "SecondaryTrdType",
  1003: "TradeID",
  1011: "MessageEventSource",
  1057: "AggressorIndicator",
  1128: "ApplVerID",
  1129: "CstmApplVerID",
  1137: "DefaultApplVerID",
};

// Message type descriptions
const MSG_TYPE_NAMES = {
  "0": "Heartbeat",
  "1": "Test Request",
  "2": "Resend Request",
  "3": "Reject",
  "4": "Sequence Reset",
  "5": "Logout",
  "6": "IOI",
  "7": "Advertisement",
  "8": "Execution Report",
  "9": "Order Cancel Reject",
  "A": "Logon",
  "B": "News",
  "C": "Email",
  "D": "New Order Single",
  "E": "New Order List",
  "F": "Order Cancel Request",
  "G": "Order Cancel/Replace Request",
  "H": "Order Status Request",
  "J": "Allocation Instruction",
  "K": "List Cancel Request",
  "L": "List Execute",
  "M": "List Status Request",
  "N": "List Status",
  "P": "Allocation Instruction Ack",
  "Q": "Don't Know Trade",
  "R": "Quote Request",
  "S": "Quote",
  "T": "Settlement Instructions",
  "V": "Market Data Request",
  "W": "Market Data Snapshot",
  "X": "Market Data Incremental Refresh",
  "Y": "Market Data Request Reject",
  "Z": "Quote Cancel",
  "a": "Quote Status Request",
  "b": "Mass Quote Acknowledgement",
  "c": "Security Definition Request",
  "d": "Security Definition",
  "e": "Security Status Request",
  "f": "Security Status",
  "g": "Trading Session Status Request",
  "h": "Trading Session Status",
  "i": "Mass Quote",
  "j": "Business Message Reject",
  "k": "Bid Request",
  "l": "Bid Response",
  "m": "List Strike Price",
  "n": "XML Message",
  "o": "Registration Instructions",
  "p": "Registration Instructions Response",
  "q": "Order Mass Cancel Request",
  "r": "Order Mass Cancel Report",
  "s": "New Order Cross",
  "t": "Cross Order Cancel/Replace Request",
  "u": "Cross Order Cancel Request",
  "v": "Security Type Request",
  "w": "Security Types",
  "x": "Security List Request",
  "y": "Security List",
  "z": "Derivative Security List Request",
  "AA": "Derivative Security List",
  "AB": "New Order Multileg",
  "AC": "Multileg Order Cancel/Replace",
  "AD": "Trade Capture Report Request",
  "AE": "Trade Capture Report",
  "AF": "Order Mass Status Request",
  "AG": "Quote Request Reject",
  "AH": "RFQ Request",
  "AI": "Quote Status Report",
  "AJ": "Quote Response",
  "AK": "Confirmation",
  "AL": "Position Maintenance Request",
  "AM": "Position Maintenance Report",
  "AN": "Request For Positions",
  "AO": "Request For Positions Ack",
  "AP": "Position Report",
  "AQ": "Trade Capture Report Request Ack",
  "AR": "Trade Capture Report Ack",
  "AS": "Allocation Report",
  "AT": "Allocation Report Ack",
  "AU": "Confirmation Ack",
  "AV": "Settlement Instruction Request",
  "AW": "Assignment Report",
  "AX": "Collateral Request",
  "AY": "Collateral Assignment",
  "AZ": "Collateral Response",
  "BA": "Collateral Report",
  "BB": "Collateral Inquiry",
  "BC": "Network Counterparty System Status Request",
  "BD": "Network Counterparty System Status Response",
  "BE": "User Request",
  "BF": "User Response",
  "BG": "Collateral Inquiry Ack",
  "BH": "Confirmation Request",
};

// Side values
const SIDE_VALUES = {
  "1": "Buy",
  "2": "Sell",
  "3": "Buy Minus",
  "4": "Sell Plus",
  "5": "Sell Short",
  "6": "Sell Short Exempt",
  "7": "Undisclosed",
  "8": "Cross",
  "9": "Cross Short",
};

// Order status values
const ORD_STATUS_VALUES = {
  "0": "New",
  "1": "Partially Filled",
  "2": "Filled",
  "3": "Done for Day",
  "4": "Canceled",
  "5": "Replaced",
  "6": "Pending Cancel",
  "7": "Stopped",
  "8": "Rejected",
  "9": "Suspended",
  "A": "Pending New",
  "B": "Calculated",
  "C": "Expired",
  "D": "Accepted for Bidding",
  "E": "Pending Replace",
};

// Exec type values
const EXEC_TYPE_VALUES = {
  "0": "New",
  "1": "Partial Fill (deprecated)",
  "2": "Fill (deprecated)",
  "3": "Done for Day",
  "4": "Canceled",
  "5": "Replaced",
  "6": "Pending Cancel",
  "7": "Stopped",
  "8": "Rejected",
  "9": "Suspended",
  "A": "Pending New",
  "B": "Calculated",
  "C": "Expired",
  "D": "Restated",
  "E": "Pending Replace",
  "F": "Trade",
  "G": "Trade Correct",
  "H": "Trade Cancel",
  "I": "Order Status",
};

/**
 * Parse a FIX message string into an array of { tag, tagName, value, displayValue } objects
 * @param {string} rawMessage - The raw FIX message
 * @returns {Array<{tag: string, tagName: string, value: string, displayValue: string}>}
 */
export const decodeFixMessage = (rawMessage) => {
  if (!rawMessage || typeof rawMessage !== "string") {
    return [];
  }

  // FIX messages use SOH (0x01) as delimiter, but may be displayed as | or ^A
  // Try to detect and split accordingly
  let delimiter = "\x01"; // SOH character
  if (!rawMessage.includes("\x01")) {
    if (rawMessage.includes("|")) {
      delimiter = "|";
    } else if (rawMessage.includes("^A")) {
      delimiter = "^A";
    } else if (rawMessage.includes("\u0001")) {
      delimiter = "\u0001";
    }
  }

  const fields = rawMessage.split(delimiter).filter(Boolean);
  const parsed = [];

  for (const field of fields) {
    const eqIndex = field.indexOf("=");
    if (eqIndex === -1) continue;

    const tag = field.substring(0, eqIndex);
    const value = field.substring(eqIndex + 1);
    const tagName = FIX_TAG_NAMES[tag] || `Tag ${tag}`;
    let displayValue = value;

    // Provide human-readable values for known tags
    if (tag === "35" && MSG_TYPE_NAMES[value]) {
      displayValue = `${value} (${MSG_TYPE_NAMES[value]})`;
    } else if (tag === "54" && SIDE_VALUES[value]) {
      displayValue = `${value} (${SIDE_VALUES[value]})`;
    } else if (tag === "39" && ORD_STATUS_VALUES[value]) {
      displayValue = `${value} (${ORD_STATUS_VALUES[value]})`;
    } else if (tag === "150" && EXEC_TYPE_VALUES[value]) {
      displayValue = `${value} (${EXEC_TYPE_VALUES[value]})`;
    }

    parsed.push({
      tag,
      tagName,
      value,
      displayValue,
    });
  }

  return parsed;
};

/**
 * Get the message type description from a parsed message
 * @param {Array} parsedMessage - Parsed FIX message array
 * @returns {string} - Message type description
 */
export const getMessageTypeDescription = (parsedMessage) => {
  const msgTypeField = parsedMessage.find((f) => f.tag === "35");
  if (!msgTypeField) return "Unknown";
  return MSG_TYPE_NAMES[msgTypeField.value] || `Unknown (${msgTypeField.value})`;
};

export { FIX_TAG_NAMES, MSG_TYPE_NAMES };
